import { styled } from 'styled-components';

export const StyledPageContainer = styled.div`
    width: 100%;
    max-width: 450px;
    padding: 0 20px;
    margin: 0 auto;
`;

export const StyledLogoWrapper = styled.div`
    padding-top: 20px;
`;

export const StyledTextWrapper = styled.div`
    text-align: center;
`;
